import { Moment } from 'moment'

export const calculateYPosition = (
  offset: Moment,
  date: Moment,
  pixelsPerHour: number
): number => pixelsPerHour * (date.diff(offset, 'minutes') / 60)
